export default __webpack_public_path__ + "static/media/greeting_card_portrait.6b4f6745.png";